import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpAction } from '../symbolLp.action';
import { SymbolLpTranslator } from '../symbolLp.translator';

type IDependencies = IClientApiDependencySegment;

export const updateSymbolLpEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(SymbolLpAction.update.started),
  mergeMap(({ params, resolve, reject }) => {
    const { lpId, data } = params;

    return dependencies.api.updateLpSymbol({
      lpId,
      ...SymbolLpTranslator.toApi(data),
    }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          SymbolLpAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SymbolLpAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
